import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
window.addEventListener('load', function () {
  setTimeout(function () {
    var mm = gsap.matchMedia();
    mm.add("(min-width: 768px)", function () {
      document.querySelectorAll(".js-scroll-trigger-lead").forEach(function (el) {
        ScrollTrigger.create({
          trigger: el,
          start: 'top 30%',
          toggleClass: {
            targets: el,
            className: "is-scroll"
          },
          // markers: true,
          once: true
        });
      });
      document.querySelectorAll(".js-scroll-trigger-lead-images").forEach(function (el) {
        ScrollTrigger.create({
          trigger: el,
          start: 'top 35%',
          toggleClass: {
            targets: el,
            className: "is-scroll"
          },
          // markers: true,
          once: true
        });
      });
      document.querySelectorAll(".js-scroll-trigger-lead-text").forEach(function (el) {
        ScrollTrigger.create({
          trigger: el,
          start: 'top 35%',
          toggleClass: {
            targets: el,
            className: "is-scroll"
          },
          // markers: true,
          once: true
        });
      });
      document.querySelectorAll(".js-scroll-trigger-products-inner").forEach(function (el) {
        ScrollTrigger.create({
          trigger: el,
          start: 'top 30%',
          toggleClass: {
            targets: el,
            className: "is-scroll"
          },
          // markers: true,
          once: true
        });
      });
      document.querySelectorAll(".js-scroll-trigger-products-list").forEach(function (el) {
        ScrollTrigger.create({
          trigger: el,
          start: 'top 45%',
          toggleClass: {
            targets: el,
            className: "is-scroll-products-list"
          },
          // markers: true,
          once: true
        });
      });
      document.querySelectorAll(".js-scroll-trigger-bodycare").forEach(function (el) {
        ScrollTrigger.create({
          trigger: el,
          start: 'top 30%',
          toggleClass: {
            targets: el,
            className: "is-scroll"
          },
          // markers: true,
          once: true
        });
      });
      document.querySelectorAll(".js-scroll-trigger-bodycare-head").forEach(function (el) {
        ScrollTrigger.create({
          trigger: el,
          start: 'top 38%',
          toggleClass: {
            targets: el,
            className: "is-scroll-bodycare-head"
          },
          // markers: true,
          once: true
        });
      });
      document.querySelectorAll(".js-scroll-trigger-bodycare-block").forEach(function (el) {
        ScrollTrigger.create({
          trigger: el,
          start: 'top 40%',
          toggleClass: {
            targets: el,
            className: "is-scroll-bodycare-block"
          },
          // markers: true,
          once: true
        });
      }); // document.querySelectorAll(".js-scroll-trigger-movie").forEach((el) => {
      //   ScrollTrigger.create({
      //     trigger: el,
      //     start: 'top 50%',
      //     toggleClass: { targets: el, className: "is-scroll" },
      //     // markers: true,
      //     once: true
      //   });
      // });

      document.querySelectorAll(".js-scroll-trigger-item").forEach(function (el) {
        ScrollTrigger.create({
          trigger: el,
          start: 'top 30%',
          toggleClass: {
            targets: el,
            className: "is-scroll"
          },
          // markers: true,
          once: true
        });
      });
      document.querySelectorAll(".js-scroll-trigger-shop").forEach(function (el) {
        ScrollTrigger.create({
          trigger: el,
          start: 'top 30%',
          toggleClass: {
            targets: el,
            className: "is-scroll"
          },
          // markers: true,
          once: true
        });
      });
      document.querySelectorAll(".js-parallax ,.js-parallax2").forEach(function (wrap) {
        gsap.to(wrap, {
          y: "-56%",
          scrollTrigger: {
            trigger: wrap,
            start: 'top bottom',
            end: '44% top',
            // 表示領域の高さ / 画像の高さ
            scrub: .5 // markers: true

          }
        });
      });
    });
    mm.add("(max-width: 767px)", function () {
      document.querySelectorAll(".js-scroll-trigger-lead").forEach(function (el) {
        ScrollTrigger.create({
          trigger: el,
          start: 'top 30%',
          toggleClass: {
            targets: el,
            className: "is-scroll"
          },
          // markers: true,
          once: true
        });
      }); // document.querySelectorAll(".js-scroll-trigger-lead-sp").forEach((el) => {
      //   ScrollTrigger.create({
      //     trigger: el,
      //     start: 'top 40%',
      //     toggleClass: { targets: el, className: "is-scroll" },
      //     // markers: true,
      //     once: true
      //   });
      // });

      document.querySelectorAll(".js-scroll-trigger-lead-title-sp").forEach(function (el) {
        ScrollTrigger.create({
          trigger: el,
          start: 'top 45%',
          toggleClass: {
            targets: el,
            className: "is-scroll"
          },
          // markers: true,
          once: true
        });
      });
      document.querySelectorAll(".js-scroll-trigger-lead-images").forEach(function (el) {
        ScrollTrigger.create({
          trigger: el,
          start: 'top 35%',
          toggleClass: {
            targets: el,
            className: "is-scroll"
          },
          // markers: true,
          once: true
        });
      });
      document.querySelectorAll(".js-scroll-trigger-lead-text-sp").forEach(function (el) {
        ScrollTrigger.create({
          trigger: el,
          start: 'top 45%',
          toggleClass: {
            targets: el,
            className: "is-scroll"
          },
          // markers: true,
          once: true
        });
      });
      document.querySelectorAll(".js-scroll-trigger-products-sp").forEach(function (el) {
        ScrollTrigger.create({
          trigger: el,
          start: 'top 35%',
          toggleClass: {
            targets: el,
            className: "is-scroll"
          },
          // markers: true,
          once: true
        });
      });
      document.querySelectorAll(".js-scroll-trigger-products-list").forEach(function (el) {
        ScrollTrigger.create({
          trigger: el,
          start: 'top 35%',
          toggleClass: {
            targets: el,
            className: "is-scroll-products-list"
          },
          // markers: true,
          once: true
        });
      });
      document.querySelectorAll(".js-scroll-trigger-products-nav").forEach(function (el) {
        ScrollTrigger.create({
          trigger: el,
          start: 'top 80%',
          toggleClass: {
            targets: el,
            className: "is-scroll-products-nav"
          },
          // markers: true,
          once: true
        });
      });
      document.querySelectorAll(".js-scroll-trigger-bodycare-head-sp").forEach(function (el) {
        ScrollTrigger.create({
          trigger: el,
          start: 'top 35%',
          toggleClass: {
            targets: el,
            className: "is-scroll-bodycare-head"
          },
          // markers: true,
          once: true
        });
      });
      document.querySelectorAll(".js-scroll-trigger-bodycare-block-sp").forEach(function (el) {
        ScrollTrigger.create({
          trigger: el,
          start: 'top 30%',
          toggleClass: {
            targets: el,
            className: "is-scroll"
          },
          // markers: true,
          once: true
        });
      });
      document.querySelectorAll(".js-scroll-trigger-item-sp").forEach(function (el) {
        ScrollTrigger.create({
          trigger: el,
          start: 'top 35%',
          toggleClass: {
            targets: el,
            className: "is-scroll"
          },
          // markers: true,
          once: true
        });
      });
      document.querySelectorAll(".js-scroll-trigger-item-block-sp").forEach(function (el) {
        ScrollTrigger.create({
          trigger: el,
          start: 'top 40%',
          toggleClass: {
            targets: el,
            className: "is-scroll-item-block"
          },
          // markers: true,
          once: true
        });
      });
      document.querySelectorAll(".js-scroll-trigger-shop-sp").forEach(function (el) {
        ScrollTrigger.create({
          trigger: el,
          start: 'top 20%',
          toggleClass: {
            targets: el,
            className: "is-scroll"
          },
          // markers: true,
          once: true
        });
      });
      document.querySelectorAll(".js-scroll-trigger-online-sp").forEach(function (el) {
        ScrollTrigger.create({
          trigger: el,
          start: 'top 40%',
          toggleClass: {
            targets: el,
            className: "is-scroll"
          },
          // markers: true,
          once: true
        });
      });
      document.querySelectorAll(".js-parallax").forEach(function (wrap) {
        gsap.to(wrap, {
          y: "-40%",
          scrollTrigger: {
            trigger: wrap,
            start: 'top bottom',
            end: '64% top',
            // 表示領域の高さ / 画像の高さ
            scrub: 0.5 // markers: true

          }
        });
      });
      document.querySelectorAll(".js-parallax2").forEach(function (wrap) {
        gsap.to(wrap, {
          y: "-30%",
          scrollTrigger: {
            trigger: wrap,
            start: 'top bottom',
            end: '64% top',
            // 表示領域の高さ / 画像の高さ
            scrub: 0.5 // markers: true

          }
        });
      });
    });
  }, 1500);
});